export const STRIPE_INTENT_REQUEST = 'STRIPE_CREATE_REQUEST'
export const STRIPE_INTENT_SUCCESS = 'STRIPE_CREATE_SUCCESS'
export const STRIPE_INTENT_FAIL = 'STRIPE_CREATE_FAIL'
